import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../../services/IFilter";

export class TicketFilter implements IFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  ticketNumberChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get ticketNumber():any {
    return this.ticketNumberChange.value;
  }
  set ticketNumber(id:any) {

    this.ticketNumberChange.next(id);
    this.emitChange("ticketNumber", id);
  }

  startTimeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get startTime():any {
    return this.startTimeChange.value;
  }
  set startTime(startTime:any) {
    this.startTimeChange.next(startTime);
    this.emitChange("startTime", startTime);
  }

  statusChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get status():any {
    return this.statusChange.value;
  }
  set status(status:any) {
    this.statusChange.next(status);
    this.emitChange("status", status);
  }

  affectedResourceTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get affectedResourceType():any {
    return this.affectedResourceTypeChange.value;
  }
  set affectedResourceType(affectedResourceType:any) {
    this.affectedResourceTypeChange.next(affectedResourceType);
    this.emitChange("affectedResourceType", affectedResourceType);
  }

  affectedResourceNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get affectedResourceName():any {
    return this.affectedResourceNameChange.value;
  }
  set affectedResourceName(affectedResourceName:any) {
    this.affectedResourceNameChange.next(affectedResourceName);
    this.emitChange("affectedResourceName", affectedResourceName);
  }

  destinationIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get destinationId():any {
    return this.destinationIdChange.value;
  }
  set destinationId(destinationId:any) {
    this.destinationIdChange.next(destinationId);
    this.emitChange("destinationId", destinationId);
  }

  siteIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get siteId():any {
    return this.siteIdChange.value;
  }
  set siteId(siteId:any) {
    this.siteIdChange.next(siteId);
    this.emitChange("siteId", siteId);
  }

  faultReasonIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get faultReasonId():any {
    return this.faultReasonIdChange.value;
  }
  set faultReasonId(faultReasonId:any) {
    this.faultReasonIdChange.next(faultReasonId);
    this.emitChange("faultReasonId", faultReasonId);
  }

  loggedByChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get loggedBy():any {
    return this.loggedByChange.value;
  }
  set loggedBy(loggedBy:any) {
    this.loggedByChange.next(loggedBy);
    this.emitChange("loggedBy", loggedBy);
  }

  assignedToChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get assignedTo():any {
    return this.assignedToChange.value;
  }
  set assignedTo(assignedTo:any) {
    this.assignedToChange.next(assignedTo);
    this.emitChange("assignedTo", assignedTo);
  }

  eventCategoryIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get eventCategoryId():any {
    return this.eventCategoryIdChange.value;
  }
  set eventCategoryId(eventCategoryId:any) {
    this.eventTypeId = undefined;
    this.eventCategoryIdChange.next(eventCategoryId);
    this.emitChange("eventCategoryId", eventCategoryId);
  }

  eventTypeIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get eventTypeId():any {
    return this.eventTypeIdChange.value;
  }
  set eventTypeId(eventTypeId:any) {
    this.eventTypeIdChange.next(eventTypeId);
    this.emitChange("eventTypeId", eventTypeId);
  }

  serviceProviderIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get serviceProviderId():any {
    return this.serviceProviderIdChange.value;
  }
  set serviceProviderId(serviceProviderId:any) {
    this.departmentId = undefined
    this.serviceProviderIdChange.next(serviceProviderId);
    this.emitChange("serviceProviderId", serviceProviderId);
  }

  departmentIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get departmentId():any {
    return this.departmentIdChange.value;
  }
  set departmentId(departmentRegionId:any) {
    this.departmentIdChange.next(departmentRegionId);
    this.emitChange("departmentId", departmentRegionId);
  }

  // tempChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  // get temp():any {
  //   return this.tempChange.value;
  // }
  // set temp(temp:any) {
  //   this.tempChange.next(temp);
  //   this.emitChange("temp", temp);
  // }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.ticketNumber && this.ticketNumber !== '') {
      params = params.set("ticketNumber", this.ticketNumber);
    }
    if (this.startTime && this.startTime !== '') {
      params = params.set("startTime", this.startTime);
    }
    if (this.status && this.status !== '' && this.status !== 'ALL') {
      params = params.set("status", this.status);
    }
    if (this.affectedResourceType && this.affectedResourceType !== '') {
      params = params.set("affectedResourceType", this.affectedResourceType);
    }
    if (this.affectedResourceName && this.affectedResourceName !== '') {
      params = params.set("affectedResourceName", this.affectedResourceName);
    }
    if (this.destinationId && this.destinationId !== '') {
      params = params.set("destinationId", this.destinationId);
    }
    if (this.siteId && this.siteId !== '') {
      params = params.set("siteId", this.siteId);
    }
    if (this.faultReasonId && this.faultReasonId !== '') {
      params = params.set("faultReasonId", this.faultReasonId);
    }
    if (this.loggedBy && this.loggedBy !== '') {
      params = params.set("loggedBy", this.loggedBy);
    }
    if (this.assignedTo && this.assignedTo !== '') {
      params = params.set("assignedTo", this.assignedTo);
    }
    if (this.eventCategoryId && this.eventCategoryId !== '') {
      params = params.set("eventCategoryId", this.eventCategoryId);
    }
    if (this.eventTypeId && this.eventTypeId !== '') {
      params = params.set("eventTypeId", this.eventTypeId);
    }
    if (this.serviceProviderId && this.serviceProviderId !== '') {
      params = params.set("serviceProviderId", this.serviceProviderId);
    }
    if (this.departmentId && this.departmentId !== '') {
      params = params.set("departmentId", this.departmentId);
    }

    return params;
  }

  setFilters(props: any): void {
    this.ticketNumberChange.next(props.ticketNumber || undefined);
    this.startTimeChange.next(props.startTime || undefined);
    this.statusChange.next(props.status || undefined);
    this.affectedResourceTypeChange.next(props.affectedResourceType || undefined);
    this.affectedResourceNameChange.next(props.affectedResourceName || undefined);
    this.destinationIdChange.next(props.destination || undefined);
    this.siteIdChange.next(props.siteId || undefined);
    this.faultReasonIdChange.next(props.faultReasonId || undefined);
    this.loggedByChange.next(props.loggedBy || undefined);
    this.assignedToChange.next(props.assignedTo || undefined);
    this.eventCategoryIdChange.next(props.eventCategoryId || undefined);
    this.eventTypeIdChange.next(props.eventTypeId || undefined);
    this.serviceProviderIdChange.next(props.serviceProviderId || undefined);
    this.departmentIdChange.next(props.departmentId || undefined);
  }

  toObj() {
    let obj:any = {};
    obj.ticketNumber = this.ticketNumber;
    obj.startTime = this.startTime;
    obj.status = this.status;
    obj.affectedResourceType = this.affectedResourceType;
    obj.affectedResourceName = this.affectedResourceName;
    obj.destination = this.destinationId;
    obj.siteId = this.siteId;
    obj.faultReasonId = this.faultReasonId;
    obj.loggedBy = this.loggedBy;
    obj.assignedTo = this.assignedTo;
    obj.eventCategoryId = this.eventCategoryId;
    obj.eventTypeId = this.eventTypeId;
    obj.serviceProviderId = this.serviceProviderId;
    obj.departmentId = this.departmentId;
    return obj;
  }


  public clear():void {
    this.ticketNumber = undefined;
    this.startTime = undefined;
    this.status = undefined;
    this.affectedResourceType = undefined;
    this.affectedResourceName = undefined;
    this.destinationId = undefined;
    this.siteId = undefined;
    this.faultReasonId = undefined;
    this.loggedBy = undefined;
    this.assignedTo = undefined;
    this.eventCategoryId = undefined;
    this.eventTypeId = undefined;
    this.serviceProviderId = undefined;
    this.departmentId = undefined;
  }
}
